"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeLastAnswer = exports.addAnswer = void 0;
const models_1 = require("../../models");
const addAnswer = (state, payload) => {
    state.value.push(payload);
};
exports.addAnswer = addAnswer;
const removeLastAnswer = (state) => {
    var _a;
    while (((_a = [...state.value].pop()) === null || _a === void 0 ? void 0 : _a.questionType) === models_1.InputType.NO_INPUT) {
        state.value.pop();
    }
    state.value.pop();
};
exports.removeLastAnswer = removeLastAnswer;
//# sourceMappingURL=chatbotAnswers.js.map